import ChairOutlinedIcon from '@mui/icons-material/ChairOutlined'
import DeckOutlinedIcon from '@mui/icons-material/DeckOutlined'
import DoorSlidingOutlinedIcon from '@mui/icons-material/DoorSlidingOutlined'
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'
import OtherHousesOutlinedIcon from '@mui/icons-material/OtherHousesOutlined'
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined'
import WheelchairPickupOutlinedIcon from '@mui/icons-material/WheelchairPickupOutlined'
import { useMediaQuery, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@rentspree/component-2023.components.atoms.typography'
import classNames from 'classnames'

import { CapetFloorOutlined, SceneOutlined, WoodFloorOutlined } from 'constant/icons'

import styles from './index.module.scss'

interface PropertyFeaturesProps {
  features: PublicListingFeature[]
}

const PropertyFeatures: React.FC<PropertyFeaturesProps> = ({ features }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  /* TODO: <img/> should utilize next/image but additional env config is require.
   * This can be improve later.
   */
  const renderFeatureIcon = (feature: PublicListingFeature) => {
    switch (feature.id) {
      case 'walkInClosets':
        return <DoorSlidingOutlinedIcon />
      case 'highCeilings':
        return <img src={SceneOutlined} alt="High ceilings" />
      case 'hardwoodFloors':
        return <img src={WoodFloorOutlined} alt="Hardwood Floors" />
      case 'furnished':
        return <ChairOutlinedIcon />
      case 'wheelchairAccessible':
        return <WheelchairPickupOutlinedIcon />
      case 'carpetedFloors':
        return <img src={CapetFloorOutlined} alt="Carpet" />
      case 'privateBalconyPatio':
        return <DeckOutlinedIcon />
      case 'openFloorPlan':
        return <SpaceDashboardOutlinedIcon />
      case 'privateEntrance':
        return <MeetingRoomIcon />
      default:
        return <OtherHousesOutlinedIcon />
    }
  }

  if (features.length === 0) return null

  return (
    <Box sx={{ paddingBottom: '40px', borderBottom: '1px solid #e0e0e0' }}>
      <Box pb={4}>
        <Typography variant="h3" fontSize={isMobile ? 24 : 32}>
          Property features
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: `repeat(${Math.ceil(features.length / 2)}, 1fr)`,
          gridAutoFlow: isMobile ? 'row' : 'column',
          gap: 2,
        }}
      >
        {features.map((feature) => (
          <Box data-testid={`feature-item-${feature.id}`} key={`feature-item-${feature.id}`}>
            <Box display="flex" flexDirection="row" gap={3} alignItems="center">
              <Box
                className={classNames(styles.featureIconContainer, { [styles.mobile]: isMobile })}
              >
                {renderFeatureIcon(feature)}
              </Box>
              <Box className={styles.featureNameContainer}>
                <Typography variant={isMobile ? 'body-large' : 'title'}>{feature.name}</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default PropertyFeatures
